import { React } from "react";
import Footer from "./footer";
import Header from "./header";
import "./screen-13.scss";

const divContentValues = [
  {
    title: "What does the world",
    subtitle: "of PM WANI look like?",
    content:
      '<span style=" font-weight:bold ">As of today, the cheapest 4G plan costs Rs. 149, which gives a daily access of 1 GB internet to an individual, for a month.</span><br /><br /> This is limited provisioning when it comes to prolonged duration of online education and content consumption. Especially across low-income households, where a family of four relies on just one such connection. This limited availability of data limits possibilities of information consumption, while consistently disrupting user experience.<br /><br /><span style=" font-weight:bold "> Consider an alternative, where a mom-and-pop store sells Wi-Fi vouchers, each giving access to unlimited data at broadband like speeds, for just Rs. 50 and other denominations.</span><br /><br /> Imagine this store immediately next to 3 to 4 low-income households, where every member of the household can access this Wi-Fi network at fast speeds, with no data limit, at nearly one third the cost of 4G.<br /><br /><span style=" font-weight:bold "> Now imagine lakhs of such stores, spread across the country, where a network effect enables users to stay connected to broadband bandwidths at all times via Wi-Fi, at almost no cost.</span><br /><br /> PM WANI promises this alternate reality. It envisions small businesses becoming digital entrepreneurs, creating a digitally empowered community across the next 500 million Indians. A community where Indians get access to high speed, low-cost, distributed broadband data on Wi-Fi; and small businesses boost their incomes by selling Wi-Fi data.<br /><br /> <span style=" font-weight:bold ">This reality is well within reach,</span> as was suggested by a recently finished pilot conducted by the Telecom Regulatory Authority of India (TRAI). This <a href="#" style=" font-weight: bold;text-decoration:underline; color:  #F4693A">pilot</a> witnessed shopkeepers earning up-to Rs. 300 daily by selling Wi-Fi vouchers of Rs. 5, 20 and 50 denominations (For most small businesses, this is equivalent to up-to a 100% increase in their daily income).<br /><br /> Small businesses became hubs for people to gather and access Wi-Fi -> from children getting access to online education to the youth and elderly consuming online content, the pilot started witnessing stories of communities coming together and getting digitally empowered.',
  },
  {
    title: "How does PM WANI",
    subtitle: "scheme work?",
    content:
      'Any small business can become a digital entrepreneur by setting up a WANI compliant Wi-Fi hotspot. By doing so, it becomes a Public Data Office or PDO (similar to how Public Calling Office or PCOs used to function). The scheme also gives provisions to Service Providers (likes of ISPs, merchant aggregators), to become PDO aggregators (PDOA), that can look after the authorisation and accounting of PDOs.<br /><br /> <span style=" font-weight:bold ">Some of the key guidelines are as follows:</span><br /><br /> <span style=" color: #F4693A ">• No registration or licensing fee is needed to become a PDO.</span> <br /><br /> <span style=" color: #F4693A ">• Any company registered in the Companies Act, 2013, can become a PDO Aggregator.</span><br /><br /> <span style=" color: #F4693A "> • PDOs will have to install WANI compliant Wi-Fi  access points infrastructure in agreement with a PDOA.</span><br /><br /> Refer to this <a  href="#" style=" color:#F4693A; text-decoration:underline;font-weight:bold">DOT policy document</a> for more details.',
  },
  {
    title: "The First",
    subtitle: "P.D.O.",
    content:
      'On January 25, 2020, in South Delhi’s Kusumpur Pahadi area, i2e1 deployed the <a  href="#" style=" color:#F4693A; text-decoration:underline;font-weight:bold">first PDO</a> in India. This was made possible by WIOM, i2e1’s ‘Made in India’ technology. <a  href="#" style=" color:#F4693A; text-decoration:underline;font-weight:bold">WIOM</a> is a WANI compliant Wi-Fi hotspot tech, that can be easily set up in less than 5 minutes by any lay-man. Check out how it works <a  href="#" style=" color:#F4693A; text-decoration:underline;font-weight:bold">here</a>.<br /><br /> <span style=" color:#204191; font-weight: bold ">Can we create a digitally empowered community across the next 500 million Indians, where ‘Wi-Fi’ becomes a house hold term, where everyone has an equal opportunity to Dream Big?</span><br /><br /> <span style=" font-weight:bold ">WIOM has already made the first move in this quest. One down, Ten Million to go. Stay tuned.</span>',
  },
];

function Screen13() {
  return (
    <div className="scr13">
      <Header />
      <div className="screen13-main" >
        <div className="heading">
          <div className="heading-title">
            <h1>PM WANI to boost small<br/>businesses and connect India</h1>
            <div>
              <div className="pp-cir">
                <div className="circ"></div>
                <hr className="pp"></hr>
                <div className="circ"></div>
              </div>
              <h2>Covid-19 severely impacted many of the<br/>6 crore small business across India</h2>
              <h2 style={{fontWeight: '100'}}>
                Affordable internet access can enable up to 85 Crore Indians to fight back
              </h2>
              <div className="pp-cir">
                <div className="circ"></div>
                <hr className="pp"></hr>
                <div className="circ"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="screen13-content">
          <div className="first-div">
            <p>
              <span style={{ fontWeight: "bold", borderTop: "2px solid black" }}>
                The
              </span>{" "}
              tale of the common man in India has always been one of struggle
              and in-sufficiency. This became quite evident in the post Covid-19
              world, when the divide between the privileged and the
              under-privileged got exposed by the pandemic.
              <br />
              <br /> Many shops shut down. From farmers to small businesses,
              incomes were drastically impacted. Even children were cut off from
              access to education.
              <br />
              <br /> It was a different story, however, across the more affluent
              segments where ‘Work from home’ and ‘Study from home’ became the
              new normal.
              <br />
              <br /> India scrambled towards going hands free and digital, but
              the common man started feeling left out. A refreshed realisation
              of struggle and in-sufficiency became his new normal.
              <br />
              <br /> In an attempt to solve for this, On Dec 9, 2020, The Govt.
              of India launched the{" "}
              <a
                href="#"
                style={{
                  color: "#F4693A",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
              >
                PM WANI scheme.
              </a>{" "}
              This scheme aims to boost the incomes of small businesses, while
              bridging the digital divide across the Indian demography.
            </p>
          </div>
          {divContentValues.map((value) => {
            return (
              <div className="content-div">
                <div>
                  <div
                    style={{
                      width: "10em",
                      height: "7em",
                      margin: "0 0.5em 0 0",
                      backgroundColor: "#204191",
                    }}
                  ></div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h1
                      style={{
                        fontSize: "3em",
                        margin: "0",
                        color: "#204191",
                      }}
                    >
                      {value.title}
                    </h1>
                    <h1
                      style={{
                        fontSize: "3em",
                        margin: "0",
                        color: "#204191",
                      }}
                    >
                      {value.subtitle}
                    </h1>
                  </div>
                </div>
                <div className="p45div">
                  <p dangerouslySetInnerHTML={{ __html: value.content }}></p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Screen13;
